'use strict';

import { module } from '../app';

module.service('Patient', [
  '$http', 'authService', 'magViewApi',
  function ($http, authService, magViewApi) {
    const magviewHistoryApiUrl = '/api/magviewhistory';
    let cachedLocationRequest = null;
    return {
      search: function (filter) {
        const url = `${authService.currentMagViewUrl()}${magViewApi}/patient/search`;

        return $http.post(url, filter);
      },
      get: function (ssn) {
        const config = { headers: authService.getTechpadDiagramHeaders() };
        const url = `${authService.currentMagViewUrl()}${magViewApi}/patient/loadPatient`;

        return $http.post(url, { ssn }, config);
      },
      getPatientStudies: function (ssn) {
        const url = `${authService.currentMagViewUrl()}${magViewApi}/patient/study/${ssn}`;
        return $http.get(url);
      },
      getPatientDetailsByAccessToken: function (accessToken) {
        const url = `${authService.currentMagViewUrl()}${magViewApi}/patient/getPatientDetailsByAccessToken?accessToken=${accessToken}`;

        return $http.get(url);
      },
      getPatientDemographicsByAccessToken: function (accessToken) {
        const url = `${authService.currentMagViewUrl()}${magViewApi}/patient/getPatientDemographicsByAccessToken?accessToken=${accessToken}`;

        return $http.get(url);
      },
      post: function (patient) {
        const url = `${authService.currentMagViewUrl()}${magViewApi}/patient/create`;

        return $http.post(url, patient);
      },
      loadLetterType: function (ssn) {
        const url = `${authService.currentMagViewUrl()}${magviewHistoryApiUrl}/loadPatientLetterType`;

        return $http.post(url, { ssn });
      },
      getLetterTypeConfig: function () {
        const url = `${authService.currentMagViewUrl()}${magviewHistoryApiUrl}/getLetterTypeConfig`;

        return $http.get(url);
      },
      getLocations: async function () {
        if (cachedLocationRequest && !cachedLocationRequest.error) {
          return cachedLocationRequest;
        }
        const url = `${authService.currentMagViewUrl()}${magViewApi}/patient/getLocations`;
        cachedLocationRequest = $http.get(url);

        return cachedLocationRequest;
      },
      saveLetterTypeAnswer: function (letterTypeAnswer, ssn) {
        const letterTypeAnswerModel = {
          LetterTypeAnswer: letterTypeAnswer,
          Ssn: ssn
        };
        const url = `${authService.currentMagViewUrl()}${magviewHistoryApiUrl}/savePatientLetterType`;

        return $http.post(url, letterTypeAnswerModel);
      },
      getCitiesByState: function (stateCode) {
        const url = `${authService.currentMagViewUrl()}/api/zip/getCitiesAndZipCodesByStateCode?stateCode=${stateCode}`;

        return $http.get(url);
      },
      getCitiStateByZip: function (zipCode) {
        const url = `${authService.currentMagViewUrl()}/api/zip/getStateAndCityByZipCode?zipCode=${zipCode}`;

        return $http.get(url);
      },
      loadPatClip: function (ssn) {
        const url = `${authService.currentMagViewUrl()}${magViewApi}/patClip/loadPatClip`;
        const model = { ssn };
        
        return $http.post(url, model);
      },
      createPatClip: function (patClip) {
        const url = `${authService.currentMagViewUrl()}${magViewApi}/patClip`;

        return $http.post(url, patClip);
      },
      updatePatClip: function (patClip) {
        const url = `${authService.currentMagViewUrl()}${magViewApi}/patClip`;

        return $http.put(url, patClip);
      },
      loadPatClipNote: function (ssn, id) {
        const url = `${authService.currentMagViewUrl()}${magViewApi}/patClipNote/loadPatClipNote`;
        const model = { ssn, id };

        return $http.post(url, model);
      },
      createPatClipNote: function (patClip) {
        const url = `${authService.currentMagViewUrl()}${magViewApi}/patClipNote/create`;

        return $http.post(url, patClip);
      },
      updatePatClipNote: function (patClip) {
        const url = `${authService.currentMagViewUrl()}${magViewApi}/patClipNote/update`;

        return $http.put(url, patClip);
      },
      deletePatClipNote: function (ssn, id) {
        const url = `${authService.currentMagViewUrl()}${magViewApi}/patClipNote/delete`;
        const model = { ssn, id };
        
        return $http.post(url, model);
      },
      getPatClipSetting: function (initUser) {
        const url = `${authService.currentMagViewUrl()}${magViewApi}/patClip/setting/${initUser}`;

        return $http.get(url);
      },
      checkPatientEmail: function (email) {
        const url = `${authService.currentMagViewUrl()}/mvwebcore.api/v3/checkPatientEmail?email=${email}`;

        return $http.get(url);
      },
      createReferringPhysician: function (referringPhysician) {
        const url = `${authService.currentMagViewUrl()}${magViewApi}/referringPhysician`;

        return $http.post(url, referringPhysician);
      },
      getUdfDefsByDbf: function (dbf) {
        const url = `${authService.currentMagViewUrl()}${magViewApi}/referringPhysician/getUdfDefsByDbf/${dbf}`;

        return $http.get(url);
      },
      getFilmsComparedConfig: function (ssn, sDate, studyDate) {
        const magviewHistoryApiUrl = '/api/MagViewHistory';
        let url = `${authService.currentMagViewUrl()}${magviewHistoryApiUrl}/GetFilmsComparedConfig?ssn=${encodeURIComponent(ssn)}&sDate=${encodeURIComponent(sDate)}`;
        
        if (studyDate) {
          url += `&studyDate=${encodeURIComponent(studyDate)}`;
        }
        
        return $http.get(url);
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/domains/patient.js